module.exports = __webpack_public_path__ + "static/media/LogicWheel2_2_drag_4.819f2d52.png";